import Vue from 'vue';

const state = {
  status: null,
  dashboard: [],
  statsData: null,
  merticChartData: null,
};

const getters = {
  dashboard(state: any) {
    return state.dashboard; 
  },
  statsData(state: any) {
    return state.statsData;
  },
  metricChartData(state: any) {
    return state.merticChartData;
  }
};

const actions = {
  async loadDashboard({ dispatch }: any) {
    let arry = [];
    arry.push(dispatch('getStatus'));
    arry.push(dispatch('getDashboard'));
    return Promise.all(arry);
  },
  async getStatus({ commit, state }: any) {
    try {
      const result: any = await Vue.axios.get(`/api/reporting/health`);
      const { data } = result;
      // console.log('dashboard Health: ', data);
      if (data) {
        commit('status', data);
      }
      
      return data;
    } catch (err) {
      console.error(err);
    }
  },
  async getDashboard({ commit, state }: any) {
    try {
      const result: any = await Vue.axios.get(`/api/reporting/dashboard`);
      const { data } = result;
      // console.log('dashboard Data: ', data);
      if (data) {
        commit('dashboard', data);
      }
      
      return data;
    } catch (err) {
      console.error(err);
    }
  },
  async getMetricChartData({ commit, state }: any, { startDate, endDate }: any) {
    try {
      const result: any = await Vue.axios.get(`/api/reporting/dashboard`, {
        params: {
          startDate,
          endDate
        }
      });
      const { data } = result;
      // console.log('Metric Data: ', data);
      if (data) {
        commit('merticChartData', data);
      }
      
      return data;
    } catch (err) {
      console.error(err);
    }
  },
};

const mutations = {
  dashboard(state: any, dashboard: any) {
    state.dashboard = dashboard;
    state.statsData = dashboard[0]['stat'];
    state.merticChartData = dashboard[1]['metrics'];
  },
  status(state: any, status: any) {
    state.status = status;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}